<mat-form-field appearance="fill">
  <mat-label>Enter a date range</mat-label>
  <mat-date-range-input [rangePicker]="picker" [max]="today" style="display: none;">
    <input matStartDate [(ngModel)]="selectedStartDate" placeholder="{{'talent-happy-path.talent-vms.employment-history.start-date' | translate}}" readonly>
    <input matEndDate [(ngModel)]="selectedEndDate" placeholder=" {{'talent-happy-path.talent-vms.employment-history.end-date' | translate}}" readonly>
  </mat-date-range-input>
  <span>
    <span class="date-field">{{ formattedDateRange }}</span>
  </span>
  <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
  <mat-date-range-picker touchUi #picker>
    <mat-datepicker-actions class="datepicker-action-button">
      <button mat-button matDatepickerCancel>{{'talent-happy-path.buttons.cancel' | translate}}</button>
      <button mat-button matDatepickerApply (click)="onDateRangeChange(picker, employmentTypeLabel)">{{'talent-happy-path.buttons.ok' | translate}}</button>
    </mat-datepicker-actions>
  </mat-date-range-picker>
</mat-form-field>
